// /api/articles.js
import api from "@/utils/axios";

// Internal helper to detect FormData and set headers
const sendRequest = (method, url, payload = {}) => {
    const config =
        payload instanceof FormData
            ? { headers: { "Content-Type": "multipart/form-data" } }
            : {};

    return api[method](url, payload, config);
};

// GET all articles with optional query params
export const getAllArticles = (params = {}) => api.get("/api/articles", { params });

// GET single article by ID
export const getArticleById = (id, params = {}) => api.get(`/api/articles/${id}`, { params });

// CREATE a new article
export const createArticle = (payload) => sendRequest("post", "/api/articles", payload);

// UPDATE an article by ID
export const updateArticle = (id, payload) => sendRequest("put", `/api/articles/${id}`, payload);

// DELETE an article by ID
export const deleteArticle = (id) => sendRequest("delete", `/api/articles/${id}`);